import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import "./plugins/vueutils";
import "./plugins/vuelodash";
import "./plugins/vueaxios";
import './plugins/vueauth';
import "./plugins/vuemoment";
import "./plugins/vuemeta";
import "./plugins/vuebar";
import "./plugins/vuelidate";
import './plugins/vuechart';
import "./plugins/vue-excel";
import "./plugins/vue-file-saver";
import "./plugins/vueupload";
import "./plugins/vue-request-builder";
import "./plugins/vue-highlight-code";
import "./plugins/vue-clipboard";

// fonts
import "typeface-lato";
import "typeface-montserrat";

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
